<app-header></app-header>
<div class="main-container d-flex">
    <app-sidebar></app-sidebar>
    <div class="h-100p overflow-y-scroll w-100 fastag-result-main">
        <div class="custom_container fastag-result-layout">
            <div class="search-container">
                <!-- Top bar -->
                <div class="search-header">
                    <div class="header-left">
                        <button class="back-button" (click)="onBackButtonClick()">
                            <i class="bi bi-arrow-left"></i>
                            <span>Back</span>
                        </button>
                    </div>
                    <div class="header-center">
                        <h1 class="search-query">{{ phonepeFastagData?.vehicle_number || selectedSearchResult?.searched_vehicle || 'Fastag Search' }}</h1>
                    </div>
                </div>

                <!-- Loader -->
                <div *ngIf="isLoadingResults" class="loading-container text-center my-3">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="mt-2 text-main-color">Fetching results, please wait...</p>
                </div>

                <div class="container container--fastag-result my-3 my-md-4 px-2 px-sm-3" *ngIf="!isLoadingResults && noRecords">
                    <div class="alert alert-warning mb-0">No Fastag Search records found for this search.</div>
                </div>

                <!-- Search Results -->
                <div class="container container--fastag-result my-3 my-md-4 px-2 px-sm-3" *ngIf="!isLoadingResults && phonepeFastagData">
                    <div class="main-fastag-details-wrapper">
                        <div class="row g-3 quick-info-row">
                            <div class="col-12 col-sm-6 col-xl-3" *ngIf="phonepeFastagData?.tag_status != null && phonepeFastagData?.tag_status !== ''">
                                <div class="info-card info-card-gender">
                                    <div class="info-card-icon">
                                        <i class="bi bi-tags"></i>
                                    </div>
                                    <div class="info-card-content">
                                        <div class="label">Tag Status</div>
                                        <h4 class="my-2">{{ phonepeFastagData.tag_status }}</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-3" *ngIf="phonepeFastagData?.vehicle_class != null && phonepeFastagData?.vehicle_class !== ''">
                                <div class="info-card info-card-dob">
                                    <div class="info-card-icon">
                                        <i class="bi bi-truck"></i>
                                    </div>
                                    <div class="info-card-content">
                                        <div class="label">Vehicle Class</div>
                                        <h4 class="my-2">{{ phonepeFastagData.vehicle_class }}</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-3" *ngIf="phonepeFastagData?.bank != null && phonepeFastagData?.bank !== ''">
                                <div class="info-card info-card-aadhaar">
                                    <div class="info-card-icon">
                                        <i class="bi bi-bank"></i>
                                    </div>
                                    <div class="info-card-content">
                                        <div class="label">Bank</div>
                                        <h4 class="my-2">{{ phonepeFastagData.bank }}</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6 col-xl-3" *ngIf="phonepeFastagData?.total_tags != null && phonepeFastagData?.total_tags !== ''">
                                <div class="info-card info-card-masked">
                                    <div class="info-card-icon">
                                        <i class="bi bi-collection"></i>
                                    </div>
                                    <div class="info-card-content">
                                        <div class="label">Total Tags</div>
                                        <h4 class="my-2">{{ phonepeFastagData.total_tags }}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Identity / Vehicle -->
                        <div class="details-box personal-details-box" *ngIf="phonepeFastagData?.vehicle_number || phonepeFastagData?.owner_name || phonepeFastagData?.vehicle_class || phonepeFastagData?.vehicle_class_code || phonepeFastagData?.commercial != null">
                            <h5 class="details-heading"><i class="bi bi-car-front"></i>Identity / Vehicle</h5>
                            <div class="row">
                                <div class="col-md-6" *ngIf="phonepeFastagData?.vehicle_number">
                                    <div class="detail-row">
                                        <p class="detail-label">Vehicle Number</p>
                                        <p>{{ phonepeFastagData.vehicle_number }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6" *ngIf="phonepeFastagData?.owner_name">
                                    <div class="detail-row">
                                        <p class="detail-label">Owner Name</p>
                                        <p>{{ phonepeFastagData.owner_name }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3" *ngIf="phonepeFastagData?.vehicle_class || phonepeFastagData?.vehicle_class_code || phonepeFastagData?.commercial != null">
                                <div class="col-md-6" *ngIf="phonepeFastagData?.vehicle_class">
                                    <div class="detail-row">
                                        <p class="detail-label">Vehicle Class</p>
                                        <p>{{ phonepeFastagData.vehicle_class }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6" *ngIf="phonepeFastagData?.vehicle_class_code">
                                    <div class="detail-row">
                                        <p class="detail-label">Vehicle Class Code</p>
                                        <p>{{ phonepeFastagData.vehicle_class_code }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6" *ngIf="phonepeFastagData?.commercial != null">
                                    <div class="detail-row">
                                        <p class="detail-label">Commercial</p>
                                        <p>{{ formatDisplay(phonepeFastagData.commercial) }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Tag -->
                        <div class="details-box personal-details-box mt-3" *ngIf="phonepeFastagData?.tag_id || phonepeFastagData?.tag_status || phonepeFastagData?.issue_date || phonepeFastagData?.total_tags != null">
                            <h5 class="details-heading"><i class="bi bi-tag"></i>Tag</h5>
                            <div class="row">
                                <div class="col-md-6" *ngIf="phonepeFastagData?.tag_id">
                                    <div class="detail-row">
                                        <p class="detail-label">Tag ID</p>
                                        <p>{{ phonepeFastagData.tag_id }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6" *ngIf="phonepeFastagData?.tag_status">
                                    <div class="detail-row">
                                        <p class="detail-label">Tag Status</p>
                                        <p>{{ phonepeFastagData.tag_status }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3" *ngIf="phonepeFastagData?.issue_date || phonepeFastagData?.total_tags != null">
                                <div class="col-md-6" *ngIf="phonepeFastagData?.issue_date">
                                    <div class="detail-row">
                                        <p class="detail-label">Issue Date</p>
                                        <p>{{ formatDate(phonepeFastagData.issue_date) }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6" *ngIf="phonepeFastagData?.total_tags != null && phonepeFastagData?.total_tags !== ''">
                                    <div class="detail-row">
                                        <p class="detail-label">Total Tags</p>
                                        <p>{{ phonepeFastagData.total_tags }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Bank / VPA -->
                        <div class="details-box personal-details-box mt-3" *ngIf="phonepeFastagData?.bank || phonepeFastagData?.bank_id || phonepeFastagData?.biller_id || phonepeFastagData?.vpa">
                            <h5 class="details-heading"><i class="bi bi-bank2"></i>Bank / VPA</h5>
                            <div class="row">
                                <div class="col-md-6" *ngIf="phonepeFastagData?.bank">
                                    <div class="detail-row">
                                        <p class="detail-label">Bank</p>
                                        <p>{{ phonepeFastagData.bank }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6" *ngIf="phonepeFastagData?.bank_id">
                                    <div class="detail-row">
                                        <p class="detail-label">Bank ID</p>
                                        <p>{{ phonepeFastagData.bank_id }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3" *ngIf="phonepeFastagData?.biller_id || phonepeFastagData?.vpa">
                                <div class="col-md-6" *ngIf="phonepeFastagData?.biller_id">
                                    <div class="detail-row">
                                        <p class="detail-label">Biller ID</p>
                                        <p>{{ phonepeFastagData.biller_id }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6" *ngIf="phonepeFastagData?.vpa">
                                    <div class="detail-row">
                                        <p class="detail-label">VPA</p>
                                        <p>{{ phonepeFastagData.vpa }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Status -->
                        <div class="details-box personal-details-box mt-3" *ngIf="phonepeFastagData?.exception_reason || phonepeFastagData?.found != null">
                            <h5 class="details-heading"><i class="bi bi-info-circle"></i>Status</h5>
                            <div class="row">
                                <div class="col-md-6" *ngIf="phonepeFastagData?.found != null">
                                    <div class="detail-row">
                                        <p class="detail-label">Found</p>
                                        <p>{{ formatDisplay(phonepeFastagData.found) }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6" *ngIf="phonepeFastagData?.exception_reason">
                                    <div class="detail-row">
                                        <p class="detail-label">Exception Reason</p>
                                        <p>{{ phonepeFastagData.exception_reason }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="notes-section mt-3">
                            <div class="notes-header">
                                <i class="bi bi-journal-text"></i>
                                <span>Add Notes</span>
                            </div>
                            <div class="notes-content">
                                <textarea class="note-input" maxlength="300" placeholder="Notes" [(ngModel)]="notes"></textarea>
                                <div class="notes-footer">
                                    <span class="character-count">{{ notes.length }}/300</span>
                                    <button type="button" class="update-button" (click)="onUpdateNotesButtonClick()">
                                        Update Notes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
